"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.setAirportFilterItemState = setAirportFilterItemState;
exports.setAllAirportFilterItemsState = setAllAirportFilterItemsState;
exports.setAllFilterItemsState = setAllFilterItemsState;
exports.setAllNestedMultiSelectFilterItemsState = setAllNestedMultiSelectFilterItemsState;
exports.setFilterItemState = setFilterItemState;
exports.setMultiSelectFilterItemState = setMultiSelectFilterItemState;
exports.setNestedMultiSelectFilterItemState = setNestedMultiSelectFilterItemState;
exports.setSingleSelectFilterItemState = setSingleSelectFilterItemState;
exports.toggleAirportFilterItemState = toggleAirportFilterItemState;
exports.toggleAllAirportFilterItemsState = toggleAllAirportFilterItemsState;
exports.toggleAllFilterItemsState = toggleAllFilterItemsState;
exports.toggleAllNestedMultiSelectFilterItemsState = toggleAllNestedMultiSelectFilterItemsState;
exports.toggleFilterItemState = toggleFilterItemState;
exports.toggleMultiSelectFilterItemState = toggleMultiSelectFilterItemState;
exports.toggleNestedMultiSelectFilterItemState = toggleNestedMultiSelectFilterItemState;
exports.updateAirportFilterState = updateAirportFilterState;
exports.updateAllFiltersState = updateAllFiltersState;
exports.updateFilterState = updateFilterState;
exports.updateFilterStateRange = updateFilterStateRange;
exports.updateMultiSelectFilterState = updateMultiSelectFilterState;
exports.updateNestedMultiSelectFilterState = updateNestedMultiSelectFilterState;
exports.updatePriceFilterState = updatePriceFilterState;
exports.updateSingleSelectFilterState = updateSingleSelectFilterState;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _queryString = _interopRequireDefault(require("query-string"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _split4 = _interopRequireDefault(require("lodash/split"));
var _toString2 = _interopRequireDefault(require("lodash/toString"));
var _filterParams = require("./filter-params.utils");
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function updateAllFiltersState(filtersState, filtersQuery) {
  var filterQueryObj = _queryString.default.parse(filtersQuery);
  var nextFiltersState = {};
  (0, _each2.default)(filtersState, function (filterState, filterKey) {
    var filterQuery = filterQueryObj[_constants.FILTER_PARAMS_MAP[filterKey]];
    nextFiltersState[filterKey] = updateFilterState({
      filterKey: filterKey,
      filterState: filterState,
      filterQuery: filterQuery
    });
  });
  return nextFiltersState;
}
function updateFilterState(_ref) {
  var filterKey = _ref.filterKey,
    filterState = _ref.filterState,
    filterQuery = _ref.filterQuery;
  switch (filterKey) {
    case 'airline':
      return updateMultiSelectFilterState(filterState, filterQuery);
    case 'airport':
      return updateAirportFilterState(filterState, filterQuery);
    case 'price':
      return updatePriceFilterState(filterState, filterQuery);
    case 'maxStop':
      return updateSingleSelectFilterState(filterState, filterQuery);
    case 'stop':
      return updateMultiSelectFilterState(filterState, filterQuery);
    case 'departureTime':
      return updateNestedMultiSelectFilterState(filterState, filterQuery);
    case 'arrivalTime':
      return updateNestedMultiSelectFilterState(filterState, filterQuery);
    case 'insuranceOnly':
      return !!filterQuery;
    case 'hasBaggageOnly':
      return filterQuery;
    case 'isFlex':
      return filterQuery;
    default:
      return undefined;
  }
}
function updateMultiSelectFilterState(filterState, filterQuery) {
  var filterParams = (0, _filterParams.generateMultiSelectFilterParams)(filterQuery);
  return (0, _map2.default)(filterState, function (filterItemState) {
    return _objectSpread(_objectSpread({}, filterItemState), {}, {
      selected: (0, _includes2.default)(filterParams, (0, _toString2.default)(filterItemState.code))
    });
  });
}
function updateSingleSelectFilterState(filterState, filterQuery) {
  var filterParams = (0, _filterParams.generateSingleSelectFilterParams)(filterQuery);
  return (0, _map2.default)(filterState, function (filterItemState) {
    return _objectSpread(_objectSpread({}, filterItemState), {}, {
      selected: (0, _includes2.default)(filterParams, (0, _toString2.default)(filterItemState.code))
    });
  });
}
function updateNestedMultiSelectFilterState(filterState, filterQuery) {
  var filterParams = (0, _split4.default)(filterQuery, _constants.FILTER_PARAM_LEG_SEPARATOR);
  return (0, _map2.default)(filterState, function (legFilterState, legIndex) {
    return updateMultiSelectFilterState(legFilterState, filterParams[legIndex]);
  });
}
function updateAirportFilterState(filterState, filterQuery) {
  var filterParams = (0, _split4.default)(filterQuery, _constants.FILTER_PARAM_LEG_SEPARATOR);
  return (0, _map2.default)(filterState, function (legFilterState, legIndex) {
    var legFilterQuery = (0, _get2.default)(filterParams, legIndex, '');
    var _split2 = (0, _split4.default)(legFilterQuery, _constants.FILTER_PARAM_AIRPORT_SEPARATOR),
      originFilterQuery = _split2[0],
      destinationFilterQuery = _split2[1];
    if (!originFilterQuery || !destinationFilterQuery) return legFilterState;
    return {
      origin: updateMultiSelectFilterState(legFilterState.origin, originFilterQuery),
      destination: updateMultiSelectFilterState(legFilterState.destination, destinationFilterQuery)
    };
  });
}
function updateFilterStateRange(filterState, filterRange) {
  if (!(0, _isPlainObject2.default)(filterRange)) {
    return filterState;
  }
  var min = filterState.min,
    max = filterState.max,
    from = filterState.from,
    to = filterState.to;
  var rangeFrom = filterRange.from,
    rangeTo = filterRange.to;
  if (isNaN(rangeFrom) || isNaN(rangeTo)) return filterState;
  return _objectSpread(_objectSpread({}, filterState), {}, {
    from: rangeFrom >= min && rangeFrom <= max ? Number(rangeFrom) : from,
    to: rangeTo >= min && rangeTo <= max ? Number(rangeTo) : to
  });
}
function updatePriceFilterState(filterState, filterQuery) {
  var _split3 = (0, _split4.default)(filterQuery, _constants.FILTER_PARAM_RANGE_SEPARATOR),
    queryFrom = _split3[0],
    queryTo = _split3[1];
  return updateFilterStateRange(filterState, {
    from: queryFrom,
    to: queryTo
  });
}
function toggleFilterItemState(_ref2) {
  var filterKey = _ref2.filterKey,
    filterState = _ref2.filterState,
    filterPayload = _ref2.filterPayload;
  switch (filterKey) {
    case 'airline':
      return toggleMultiSelectFilterItemState(filterState, filterPayload);
    case 'insuranceOnly':
      return !filterState;
    case 'airport':
      return toggleAirportFilterItemState(filterState, filterPayload);
    case 'stop':
      return toggleMultiSelectFilterItemState(filterState, filterPayload);
    case 'maxStop':
      return toggleMultiSelectFilterItemState(filterState, filterPayload);
    case 'departureTime':
      return toggleNestedMultiSelectFilterItemState(filterState, filterPayload);
    case 'arrivalTime':
      return toggleNestedMultiSelectFilterItemState(filterState, filterPayload);
    case 'hasBaggageOnly':
      return !filterState;
    case 'isFlex':
      return !filterState;
    default:
      return undefined;
  }
}
function toggleMultiSelectFilterItemState(filterState, filterPayload) {
  if (!(0, _isPlainObject2.default)(filterPayload)) {
    return filterState;
  }
  var code = filterPayload.code;
  return (0, _map2.default)(filterState, function (filterItemState) {
    var selected = filterItemState.code === code ? !filterItemState.selected : filterItemState.selected;
    return _objectSpread(_objectSpread({}, filterItemState), {}, {
      selected: selected
    });
  });
}
function setSingleSelectFilterItemState(filterState, filterPayload) {
  if (!(0, _isPlainObject2.default)(filterPayload)) {
    return filterState;
  }
  return (0, _map2.default)(filterState, function (filterItemState) {
    return _objectSpread(_objectSpread({}, filterItemState), {}, {
      selected: filterItemState.code === filterPayload.code
    });
  });
}
function toggleNestedMultiSelectFilterItemState(filterState, filterPayload) {
  if (!(0, _isPlainObject2.default)(filterPayload)) {
    return filterState;
  }
  var index = filterPayload.index,
    code = filterPayload.code;
  return (0, _map2.default)(filterState, function (legFilterState, legIndex) {
    return legIndex === index ? toggleMultiSelectFilterItemState(legFilterState, {
      code: code
    }) : legFilterState;
  });
}
function toggleAirportFilterItemState(filterState, filterPayload) {
  if (!(0, _isPlainObject2.default)(filterPayload) || !['origin', 'destination'].includes(filterPayload.type)) {
    return filterState;
  }
  var type = filterPayload.type,
    index = filterPayload.index,
    code = filterPayload.code;
  return (0, _map2.default)(filterState, function (legFilterState, legIndex) {
    var _objectSpread2;
    var typeFilterState = legIndex === index ? toggleMultiSelectFilterItemState(legFilterState[type], {
      code: code
    }) : legFilterState[type];
    return _objectSpread(_objectSpread({}, legFilterState), {}, (_objectSpread2 = {}, _objectSpread2[type] = typeFilterState, _objectSpread2));
  });
}
function toggleAllFilterItemsState(_ref3) {
  var filterKey = _ref3.filterKey,
    filterState = _ref3.filterState,
    filterCode = _ref3.filterCode;
  switch (filterKey) {
    case 'airline':
      return toggleMultiSelectFilterItemState(filterState, filterCode);
    case 'airport':
      return toggleAllAirportFilterItemsState(filterState, filterCode);
    case 'stop':
      return toggleMultiSelectFilterItemState(filterState, filterCode);
    case 'departureTime':
      return toggleAllNestedMultiSelectFilterItemsState(filterState, filterCode);
    case 'arrivalTime':
      return toggleAllNestedMultiSelectFilterItemsState(filterState, filterCode);
    default:
      return undefined;
  }
}
function toggleAllNestedMultiSelectFilterItemsState(filterState, filterCode) {
  return (0, _map2.default)(filterState, function (legFilterState) {
    return toggleMultiSelectFilterItemState(legFilterState, {
      code: filterCode
    });
  });
}
function toggleAllAirportFilterItemsState(filterState, filterCode) {
  return (0, _map2.default)(filterState, function (legFilterState) {
    return {
      origin: toggleMultiSelectFilterItemState(legFilterState.origin, {
        code: filterCode
      }),
      destination: toggleMultiSelectFilterItemState(legFilterState.destination, {
        code: filterCode
      })
    };
  });
}
function setFilterItemState(_ref4) {
  var filterKey = _ref4.filterKey,
    filterState = _ref4.filterState,
    filterPayload = _ref4.filterPayload;
  switch (filterKey) {
    case 'airline':
      return setMultiSelectFilterItemState(filterState, filterPayload);
    case 'airport':
      return setAirportFilterItemState(filterState, filterPayload);
    case 'stop':
      return setMultiSelectFilterItemState(filterState, filterPayload);
    case 'maxStop':
      return setSingleSelectFilterItemState(filterState, filterPayload);
    case 'departureTime':
      return setNestedMultiSelectFilterItemState(filterState, filterPayload);
    case 'arrivalTime':
      return setNestedMultiSelectFilterItemState(filterState, filterPayload);
    case 'insuranceOnly':
      return Boolean(filterPayload);
    case 'hasBaggageOnly':
      return Boolean(filterPayload);
    case 'isFlex':
      return Boolean(filterPayload);
    default:
      return undefined;
  }
}
function setMultiSelectFilterItemState(filterState, filterPayload) {
  if (!(0, _isPlainObject2.default)(filterPayload)) {
    return filterState;
  }
  var code = filterPayload.code,
    nextSelected = filterPayload.selected;
  return (0, _map2.default)(filterState, function (filterItemState) {
    var selected = filterItemState.code === code ? nextSelected : filterItemState.selected;
    return _objectSpread(_objectSpread({}, filterItemState), {}, {
      selected: selected
    });
  });
}
function setNestedMultiSelectFilterItemState(filterState, filterPayload) {
  if (!(0, _isPlainObject2.default)(filterPayload)) {
    return filterState;
  }
  var index = filterPayload.index,
    code = filterPayload.code,
    selected = filterPayload.selected;
  return (0, _map2.default)(filterState, function (legFilterState, legIndex) {
    return legIndex === index ? setMultiSelectFilterItemState(legFilterState, {
      code: code,
      selected: selected
    }) : legFilterState;
  });
}
function setAirportFilterItemState(filterState, filterPayload) {
  if (!(0, _isPlainObject2.default)(filterPayload) || !['origin', 'destination'].includes(filterPayload.type)) {
    return filterState;
  }
  var type = filterPayload.type,
    index = filterPayload.index,
    code = filterPayload.code,
    selected = filterPayload.selected;
  return (0, _map2.default)(filterState, function (legFilterState, legIndex) {
    var _objectSpread3;
    var typeFilterState = legIndex === index ? toggleMultiSelectFilterItemState(legFilterState[type], {
      code: code,
      selected: selected
    }) : legFilterState[type];
    return _objectSpread(_objectSpread({}, legFilterState), {}, (_objectSpread3 = {}, _objectSpread3[type] = typeFilterState, _objectSpread3));
  });
}
function setAllFilterItemsState(_ref5) {
  var filterKey = _ref5.filterKey,
    filterState = _ref5.filterState,
    filterPayload = _ref5.filterPayload;
  switch (filterKey) {
    case 'airline':
      return setMultiSelectFilterItemState(filterState, filterPayload);
    case 'airport':
      return setAllAirportFilterItemsState(filterState, filterPayload);
    case 'stop':
      return setMultiSelectFilterItemState(filterState, filterPayload);
    case 'departureTime':
      return setAllNestedMultiSelectFilterItemsState(filterState, filterPayload);
    case 'arrivalTime':
      return setAllNestedMultiSelectFilterItemsState(filterState, filterPayload);
    default:
      return undefined;
  }
}
function setAllNestedMultiSelectFilterItemsState(filterState, filterPayload) {
  return (0, _map2.default)(filterState, function (legFilterState) {
    return setMultiSelectFilterItemState(legFilterState, filterPayload);
  });
}
function setAllAirportFilterItemsState(filterState, filterPayload) {
  return (0, _map2.default)(filterState, function (legFilterState) {
    return {
      origin: setMultiSelectFilterItemState(legFilterState.origin, filterPayload),
      destination: setMultiSelectFilterItemState(legFilterState.destination, filterPayload)
    };
  });
}
var _default = exports.default = {
  updateFilterState: updateFilterState,
  updateAllFiltersState: updateAllFiltersState,
  toggleFilterItemState: toggleFilterItemState,
  toggleAllFilterItemsState: toggleAllFilterItemsState,
  setFilterItemState: setFilterItemState,
  setAllFilterItemsState: setAllFilterItemsState,
  updateFilterStateRange: updateFilterStateRange
};